module.exports = __webpack_public_path__ + "img/norway-cervical-cancer-female.7e21061b.png";